<template>
  <footer class="c-footer py-4" :class="{'opacity-0': showFooter}">
    <div
      class="container d-flex flex-column flex-md-row justify-content-between
      align-items-center"
    >
      <a
        v-if="general.data.information"
        target="_blank"
        :href="general.data.information.libro_reclamaciones"
        class="c-footer__link mb-3 mb-md-0"
      >
        <span class="fs-21">
          <!--<Icon icon="ph:book-open"/>-->
          <img :src="general.data.information.footer.texto_izquierda.icono"
          style="width: 21px;" alt="">
        </span>
        {{ general.data.information.footer.texto_izquierda.texto }}
      </a>
      <div
      class="d-flex flex-column flex-md-row justify-content-center gap-2 gap-lg-4
      align-items-center text-center"
      style="text-decoration: underline;"
    >
      <a
        v-if="general.data.information.footer.link_1.link"
        target="_blank"
        :href="general.data.information.footer.link_1.link"
        class="c-footer__link mb-3 mb-md-0"
        style="font-weight: 400;"
      >
        Cambio de Zonificación
      </a>
      <a
        v-if="general.data.information.footer.link_2.link"
        target="_blank"
        :href="general.data.information.footer.link_2.link"
        class="c-footer__link mb-3 mb-md-0"
        style="font-weight: 400;"
      >
        Licencia de Habilitación y Construcción
      </a>
      <a
        v-if="general.data.information.footer.link_3.link"
        target="_blank"
        :href="general.data.information.footer.link_3.link"
        class="c-footer__link mb-3 mb-md-0"
        style="font-weight: 400;"
      >
        Factibilidad de Agua
      </a>
      <a
        v-if="general.data.information.footer.link_4.link"
        target="_blank"
        :href="general.data.information.footer.link_4.link"
        class="c-footer__link mb-3 mb-md-0"
        style="font-weight: 400;"
      >
        Factibilidad de Energía Eléctrica
      </a>
    </div>
      <div
        v-if="general.data.information"
        class="c-social c-social--secondary"
      >
        <a
          v-if="general.data.information.social.facebook"
          :href="general.data.information.social.facebook"
          target="_blank"
          class="c-social__link me-2"
        >
          <Icon icon="ri:facebook-fill"/>
        </a>
        <a
          v-if="general.data.information.social.youtube"
          :href="general.data.information.social.youtube"
          target="_blank"
          class="c-social__link me-2"
        >
          <Icon icon="ph:youtube-logo-fill"/>
        </a>
        <a
          v-if="general.data.information.social.linkedin"
          :href="general.data.information.social.linkedin"
          target="_blank"
          class="c-social__link me-2"
        >
          <Icon icon="ri:linkedin-fill"/>
        </a>
        <a
          v-if="general.data.information.social.tiktok"
          :href="general.data.information.social.tiktok"
          target="_blank"
          class="c-social__link me-2"
        >
          <Icon icon="ic:baseline-tiktok"/>
        </a>
        <a
          v-if="general.data.information.social.instagram"
          :href="general.data.information.social.instagram"
          target="_blank"
          class="c-social__link"
        >
          <Icon icon="mdi:instagram"/>
        </a>
      </div>
    </div>
    <div class="container mt-4 mb-5 mb-md-0 mt-md-3 d-flex justify-content-center">
      <p class="fs-16 w-regular gray-xlight mb-3 mb-md-0">
        {{ general.data.information.footer.texto_central}}
      </p>
    </div>

  </footer>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      year: new Date().getFullYear(),
      showFooter: true,
    };
  },
  computed: {
    ...mapState(['general']),
  },
  mounted() {
    setTimeout(() => {
      this.showFooter = false;
    }, 3000);
  },
};
</script>
